import { render } from "./KampanaBalata.vue?vue&type=template&id=aa4139a2"
import script from "./KampanaBalata.vue?vue&type=script&lang=js"
export * from "./KampanaBalata.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__